module.exports = __webpack_public_path__ + "img/pending_zone_selected.dbe7ac21.svg";